import { viewsetActions } from '@/service/plugin';

const pricebookEntries = viewsetActions('pricebook-entries');

export default {
  pricebookEntries,
};
